package com.swetdot.swetgram.data.links

import com.swetdot.swetgram.data.api.ApiClient
import com.swetdot.swetgram.protocol.dto.ResolvedLink
import io.ktor.client.request.parameter

class LinkRepository(private val api: ApiClient) {
    suspend fun resolve(url: String): ResolvedLink = api.get("links/resolve") {
        parameter("url", url)
    }
}
